import { ApplicationProfile } from '@shared/models';

export interface ApplicationProfileState {
  profile?: ApplicationProfile;
}
